import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { abileneConfig } from "./data";

export default function AbilenePage() {
  return <CityPageTemplate config={abileneConfig} />;
}